const roundUpToDivisor = (value: number, divisor: number): number => {
    const rem = value % divisor

    return rem === 0 ? value : value + divisor - rem
}

export const getMapMarkerIcon = (
    percentage: number | string | null | undefined,
    isMonitored: boolean | undefined,
    isAlarm: boolean | undefined,
): string => {
    if (!isMonitored) {
        return '/images/oil-level-markers/notMonitored.svg'
    }

    if (isAlarm) {
        return '/images/oil-level-markers/alarm.svg'
    }

    const numeric = Number(percentage)
    const safe = Number.isFinite(numeric) ? numeric : 0
    const rounded = Math.min(Math.max(roundUpToDivisor(safe, 5), 10), 100)

    return `/images/oil-level-markers/${rounded > 100 ? 100 : rounded}.svg`
}
